'use client';

import { PageNavigation as BasePageNavigation } from '@/components/client';
import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

interface PageNavigationProps {
  title?: string;
}

export const PageNavigation = ({ title }: PageNavigationProps) => {
  const subDomain = useDeviceInfoStore((state) => state.subDomain);

  return (
    <BasePageNavigation
      backButton={subDomain !== SUB_DOMAIN.TOSS}
      hideHomeButton={subDomain === SUB_DOMAIN.TOSS}
      title={title}
    />
  );
};
